export default "__VITE_ASSET__C0R5AWrM__"